// extracted by mini-css-extract-plugin
export default {"indicator-container":"telestration-video-controls_indicator-container__hrTNg","indicator":"telestration-video-controls_indicator__vvddB"};